// src/pwa/installPrompt.js
let deferredPrompt = null;
let autoPromptHandler = null;

const cleanupAutoPrompt = () => {
  if (autoPromptHandler) {
    window.removeEventListener("pointerdown", autoPromptHandler);
    autoPromptHandler = null;
  }
};

const hideInstallButton = () => {
  const btn = document.getElementById("install-app-btn");
  if (btn) {
    btn.classList.add("hidden");
  }
};

const scheduleAutoPrompt = () => {
  cleanupAutoPrompt();
  autoPromptHandler = async () => {
    cleanupAutoPrompt();
    await promptInstall();
  };
  window.addEventListener("pointerdown", autoPromptHandler, { once: true });
};

export function registerInstallPrompt() {
  window.addEventListener("beforeinstallprompt", (event) => {
    const installButton = document.getElementById("install-app-btn");

    if (!installButton) {
      // No custom UI; allow the browser to handle it normally.
      deferredPrompt = null;
      return;
    }

    event.preventDefault();
    deferredPrompt = event;
    installButton.classList.remove("hidden");

    // If the user interacts with the page (tap/click) without pressing the install button,
    // automatically show the prompt so the browser stops warning in the console.
    scheduleAutoPrompt();
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    cleanupAutoPrompt();
    hideInstallButton();
  });
}

export async function promptInstall() {
  if (!deferredPrompt) return null;

  // Capture and clear the stored event so it can't be reused accidentally.
  const promptEvent = deferredPrompt;
  deferredPrompt = null;
  cleanupAutoPrompt();

  try {
    // `prompt()` must be followed by awaiting `userChoice` for the result.
    promptEvent.prompt();
    const choice = await promptEvent.userChoice;
    hideInstallButton();
    return choice?.outcome || null;
  } catch (error) {
    hideInstallButton();
    return null;
  }
}

// Make it available globally for inline onclick handlers
window.__promptInstall = promptInstall;
